var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToasterErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error",
    transform: "translate(-766 -1354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email_message",
    "data-name": "email message",
    transform: "translate(578 698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(188 656)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(0 0)",
    fill: "rgba(250,22,22,0.9)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "close-outline",
    d: "M149,149l-5-5m5,0-5,5",
    transform: "translate(627.5 1215.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterErrorIcon);
export default __webpack_public_path__ + "static/media/toaster-error-icon.32e41c20f739823dc20b0ada52398f9b.svg";
export { ForwardRef as ReactComponent };